import Vue from 'vue'

const globalEventBus = new Vue()

export default {
	install(Vue) {
		Vue.prototype.$eventBus = globalEventBus
	}
}
